import React from "react";
import ExperienceCard from "./ExperienceCard";
import { experiences } from "../../data/experiences";

function Experiences() {
  return (
    <main className="page page--interior">
      <header className="page-header">
        <p className="section-kicker">Experience</p>
        <h1 className="section-title">Where I have been</h1>
        <p className="page-lead">
          Teams, products, and a few problems I was lucky enough to stay with.
        </p>
      </header>

      <ol className="experience-list">
        {experiences.map((exp) => (
          <li key={exp.company + exp.title}>
            <ExperienceCard experience={exp} />
          </li>
        ))}
      </ol>
    </main>
  );
}

export default Experiences;
